import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HomeIcon } from '../../../../components/ui/icons';
import styles from './Breadcrumbs.module.css';

export default function Breadcrumbs({ items = [] }) {
  const { t } = useTranslation('header');

  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <Link
          to='/'
          className={styles.homeLink}
          aria-label={t('BREADCRUMB_HOME')}>
          <HomeIcon width={12.33} height={12.03} />
        </Link>
        {items.map((item, i) => (
          <React.Fragment key={i}>
            <span className={styles.sep} aria-hidden='true'>
              ›
            </span>
            {item.href ? (
              <Link to={item.href} className={styles.crumb}>
                {item.label}
              </Link>
            ) : (
              <span className={styles.crumbCurrent}>{item.label}</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
